<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <ExercicioForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ExercicioForm from "../../../components/forms/ExercicioForm.vue";
import { ExercicioService } from "../../../services/ExercicioService";

export default {
  name: "CriarExercicio",
  components: {
    Breadcrumb,
    ExercicioForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Exercícios",
          disabled: false,
          href: "/gerenciar-exercicios"
        },
        {
          text: "Criar Exercício",
          disabled: true,
          href: "/exercicios/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("ano", formData.exercicio);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await ExercicioService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de exercícios após salvar
          this.$router.push('/gerenciar-exercicios');
        } else {
          throw new Error('Erro ao criar exercício');
        }
      } catch (error) {
        console.error('Erro ao criar exercício:', error);
        // O componente ExercicioForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-exercicios');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>